<a [href]="href" rel="noopener" [target]="target">
  <img class="zoom" [title]="title" [src]="src" />
</a>
